<template>

    <div class="columns is-gapless">

        <div class="is-narrow"  ref="organizationBody">

            <div class="card" style="border-radius:0">

                <div class="card-content has-background-light" style="height:calc(100vh - 50px); padding-bottom: 15px;">

                    <organizations :organization.sync="selectedOrganization" :selectedFirm.sync="selectedFirm"

                    ref="organizations" :organizationArchived="organizationArchived" :organizations.sync="organizations"/>

                </div>

            </div>

        </div>

        <div class="no-wrap has-background-white" style="width:100%">

            <div class="columns is-gapless is-multiline">

                <div class="column is-12">

                    <div style="display:flex; padding: 15px 15px 0px;" class="firm-header">

                        <div class="firm-header--title" style="display:flex;">

                            <div ref="firmInputName" @keydown.enter.prevent v-on:keyup.13="hide" class="title" :contenteditable="content" v-click-outside="hide"

                            @click="toggle">{{ newFirmName ? newFirmName : 'LOADING' }}</div>

                            <i class="fa fa-times-circle" v-if="contenteditable" style="padding: 3px 10px; font-size: 20px; color: red;" @click="buttonClose=false"></i>

                        </div>

                        <star-rating class="mb-1" :increment ="0.1" :rating="ratings" :star-size="20" :show-rating="false" :class="'star-rating'" read-only />

                        <!-- <template v-if="selectedFirm && $store.state.Auth.user.firmId != selectedFirm.firm.id">

                            <button class="button archive-button is-warning" @click="archive('restore', selectedFirm.id, $event)" v-if="selectedFirm.archived_at == null">ARCHIVE</button>

                            <button class="button archive-button is-dark" @click="archive('restore', selectedFirm.id, $event)" style="float:right;" v-else>Restore</button>

                        </template> -->

                        <div style="margin-left: 1rem;" v-if="selectedFirm && $store.state.Auth.user.firmId != selectedFirm.firm.id">
                            <archive-restore-button :firm="selectedOrganization" @archive="onArchiveRestore" @restore="onArchiveRestore"></archive-restore-button>
                        </div>

                        <div style="margin-left: 1rem;" v-if="selectedFirm && $store.state.Auth.user.firmId == selectedFirm.firm.id">
                            <terminate-button :firm="selectedOrganization"></terminate-button>
                        </div>

                    </div>

                </div>

                <div class="column is-12">

                    <div style="height:calc(100vh - 50px - 66px); overflow-y:scroll;">

                        <b-loading :active="divLoading && !(selectedFirm && selectedOrganization)" :is-full-page="divLoadingFullpage"></b-loading>

                        <organization-data :selectedOrganization.sync="selectedOrganization" :selectedFirm.sync="selectedFirm"

                        @refetchOrganization="refetchOrganization" @refetchFirm="refetchFirm" v-if="selectedFirm && selectedOrganization"

                        :organizations.sync="organizations" @updateLogo="updateLogo" />

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

import Organizations from "./organizationData/organizations";

import OrganizationData from "./organizationData/organizationDetails";

import Persons from "./persons/index";

import UserForm from "./persons/userForm";

import TerminateButton from "./partials/TerminateButton";

import ArchiveRestoreButton from "./partials/ArchiveRestoreButton";

import Permissions from "@/helpers/permissions";

import Roles from "@/helpers/roles";

import { startRouteMixin } from "@/mixins/startRouteMixin";

import { AuthService } from "@/services/auth.service";

import { UserService } from "@/services/user.service";

import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

import { AssociatedService } from "@/services/associated.service";

import StarRating from "vue-star-rating";

import ClickOutside from 'vue-click-outside'

export default {

    components: {
        TerminateButton,

        ArchiveRestoreButton,

        Organizations, OrganizationData, Persons, UserForm, StarRating

    },

    data() {

        return {

            selectedOrganization: null,

            selectedFirm: null,

            createUser: false,

            person: null,

            teleporting: 0,

            deleting: false,

            archiving: false,

            archivedAt: false,

            restoring: false,

            organizationArchived: true,

            organizations: [],

            divLoading: true,

            divLoadingFullpage: false,

            editFirm: false,

            newFirmName: '',

            contenteditable: false,

            content: true,

            buttonClose: true,

        }

    },

    watch: {

        selectedFirm(value) {

            this.person = null;

            this.newFirmName = value.firm.name

        },

        newFirmName(value, previous) {

            // if (previous) {

            //     this.updateFirmName();

            // }

        },

    },

    methods: {
        updateLogo(data) {
            if (data.firm.logo) {
                this.selectedFirm.firm.logo = data.firm.logo
            }
        },
        canTeleportAs(user) {

            return this.isSuperAdmin ||

                   this.$store.getters["Auth/hasPermission"](Permissions.CAN_TELEPORT_AS_COLLEAGUE) &&

                   this.$store.state.Auth.user.firmId == user.firmId;

        },

        async updateFirmName() {

            AssociatedService.updateFirmName({id: this.selectedOrganization, firm_firm_id: this.selectedFirm.id, name: this.newFirmName}).then(response => {

                this.refetchFirm();

                this.selectedFirm = response;

                this.$buefy.toast.open({

                    message: 'Organisation name successfully updated.',

                    type: "is-info",

                    position: "is-top-right"

                });

                this.editFirm = false;

                this.content = true;

                // this.$emit('updateFirm', response)

            }).catch(error => {

                this.newFirmName = this.selectedFirm.firm.name;

            });

        },

        async teleport(id) {

            this.teleporting = id;

            try {

                const token = await AuthService.teleport({id}).then(response => response.data.token);

                this.$store.dispatch("Auth/setToken", token);

                this.navigateToStartRoute();

            } catch (err) {}

        },

        onRemove() {

            this.$buefy.dialog.confirm({

                title: "Confirm",

                message: "Are you sure you want to <b>delete</b> this user?",

                confirmText: "Delete",

                type: "is-danger",

                hasIcon: true,

                onConfirm: () => {

                    this.remove();

                }

            });

        },

        async remove() {

            this.deleting = true;

            try {

                await UserService.delete(this.person.id);

                this.$buefy.toast.open({

                    message: "User has been deleted.",

                    type: "is-info",

                    position: "is-top-right"

                });

                this.$refs.person.refetch();

                this.person = null;

            } catch (err) {}

            this.deleting = false;
        },

        // async archive() {

        //     this.archiving = true;

        //     try {
        //         // console.log('test, test');

        //         const response = await UserService.archive(this.person.id, {

        //             includes: "permissions,roles"

        //         });

        //         const person = JsonDenormalizer.denormalize(response);

        //         this.$buefy.toast.open({

        //             message: "User has been archived.",

        //             type: "is-info",

        //             position: "is-top-right"

        //         });

        //         this.person = person;

        //         this.$refs.person.refetch();

        //     } catch (err) {}

        //     this.archiving = false;
        // },


        // async restore() {

        //     this.restoring = true;

        //     try {

        //         const response = await UserService.restore(this.person.id, {

        //             includes: "permissions,roles"

        //         });

        //         const person = JsonDenormalizer.denormalize(response);

        //         this.$buefy.toast.open({

        //             message: "User has been restored.",

        //             type: "is-info",

        //             position: "is-top-right"

        //         });

        //         this.person = person;

        //         this.$refs.person.refetch();

        //     } catch (err) {}

        //     this.restoring = false;
        // },


        async archive(type, id, event) {

            AssociatedService.archive({id: id}).then(response => {

                this.$buefy.toast.open({

                    message: type == 'archive' ? 'Associated Organization has been archived.' : 'Associated Organization has been restored.',

                    type: "is-info",

                    position: "is-top-right"

                });

                this.refetchFirm();

                this.selectedFirm = response;

                // this.$refs.comboboxFirms.fetchOptions(1, false);

            });


        },

        refetchOrganization() {

            this.$refs.organizations.fetch();

            // this.$refs.organizations.fetchFirm();

        },

        refetchFirm() {

            // this.$refs.organizations.fetch();
            this.$refs.organizations.fetchFirm();

        },

        userFormCallback(data){

            this.person = data ? data : null;

            this.$refs.person.refetch();

        },

        reset() {

            this.$refs.organizations.reset();

        },

        toggle () {

            // alert('toggle');

            this.buttonClose = true;

            this.contenteditable = true

            // this.$nextTick(() => {

            //     this.$refs.firmInputName.focus();

            // })

        },

        hide () {

            this.content = false;

            this.contenteditable = false

            this.newFirmName = this.$refs.firmInputName.innerHTML;

            this.$nextTick(() => {

                if (this.newFirmName != this.selectedFirm.firm.name && this.buttonClose) {

                    this.updateFirmName();

                }else{

                    this.newFirmName = this.selectedFirm.firm.name;

                    this.content = true;

                }

            })

        },

        onArchiveRestore() {
            this.refetchFirm();
            this.refetchOrganization();
        },

    },

    computed: {

        isSuperAdmin() {

            return this.$store.getters["Auth/hasRole"](Roles.SUPERADMIN);

        },

        canManageUsers() {

            return this.$store.getters["Auth/hasPermission"]("can manage users");

        },

        ratings() {

            if (this.selectedOrganization && this.selectedOrganization.ratings.length) {

                let ratings = this.selectedOrganization.ratings.map(element => element.rating);

                const total = ratings.reduce((acc, c) => acc + c, 0);

                return total / ratings.length;

            }

            return 0;

        },

    },

    mounted() {

        // alert();

    },

    directives: {

        ClickOutside

    }

};

</script>

<style lang="scss" scoped>

    .organization-header{

        padding:0px;

    }

    .organization-header button{
        height: 37px;
        width: 80px;
        border: 0px;
        font-weight: bold;
    }
    .organization-header .active{

        background: #209cee;
        color: white;

    }

    .card-content {
        padding: 0;
        overflow: auto;
    }

    .person-create, .organization-archived {
        position: absolute;
        right: 0px;
        margin-right: 7px;
    }

    .show-archived {
        position: absolute;right: 0px;
        margin-right: 10px;
    }

    .button-div{
        margin-top: 8px;
        margin-right: 7px;
    }

    .firm-header{
        margin-bottom: 10px;
    }

    .firm-header .title{
        margin-bottom: 0px;
    }

    .star-rating{
        margin-left: 12px;
        margin-bottom: 0px;
    }

    .edit-firm-name{

        border:1px solid #fff;

    }

    .edit-firm-name:hover{

        border:1px solid #dbdbdb;

    }

    .firm-header--title .edit-firm-name {
        visibility: hidden;
    }

    .firm-header--title:hover {
        .edit-firm-name {
            visibility: visible;
        }
    }

    .archive-button{
        position: absolute;
        right: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/components/pages/Organization/index.vue